import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $authors } from "../../internal/deep-link/author.atom";

export const useAuthorsFromGithub = (authorId: string) => {
	const loadableAuthorAtom = loadable($authors(authorId));
	const author = useAtomValue(loadableAuthorAtom);

	return {
		isLoading: author.state === "loading",
		author: author.state === "hasData" ? author.data : null,
		error: author.state === "hasError" ? author.error : null,
	};
};
